import type { ProfileSlice } from '.';
import { action } from '@play-co/replicant';
import { profileRuleset } from './profile.ruleset';
import { defineActions } from '../utils';

export const profileActions = defineActions<ProfileSlice>()({
  /**
   * Confirm user consent and update public profile
   */
  updatePublicProfile: action(
    (
      state,
      args: {
        name?: string;
        photo?: string;
      },
    ) => {
      const [minLength, maxLength] = profileRuleset.nameLength;

      if (args.name?.length < minLength || args.name?.length > maxLength) {
        throw new Error(
          `Name must be between ${minLength} and ${maxLength} characters`,
        );
      }

      state.publicProfile = {
        ...(state.publicProfile ?? {}),
        ...args,
      };
    },
  ),

  /**
   * @warning Only for internal usage, other users should not see this information
   *
   * Update profile image and name on login automatically,
   * it will take current line photo and name
   * We can't show this information to other users !!!
   */
  updatePrivateProfile: action(
    (state, args: { name?: string; photo?: string }) => {
      if (!state.profile) state.profile = {};
      state.profile.name = args.name || undefined;
      state.profile.photo = args.photo || undefined;
    },
  ),
});
